function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};
window.recentlyViewedIds = [];

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = this.input.getAttribute('step');
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');

      // Add functionality to buttons
      this.subtract.addEventListener('click', () => this.change_quantity(-1 * this.step));
      this.add.addEventListener('click', () => this.change_quantity(1 * this.step));

    }
    connectedCallback() {
      this.classList.add('buttons_added');
      this.validateQtyRules();
    }
    change_quantity(change) {
      let quantity = Number(this.input.value);
      if (isNaN(quantity)) quantity = 1;

      const minAttr = this.input.getAttribute('min');
      const min = minAttr !== null && minAttr !== '' ? Number(minAttr) : 1;
      const maxAttr = this.input.getAttribute('max');
      const next = quantity + Number(change);

      if (next < min) {
        return;
      }
      if (maxAttr && Number(maxAttr) < next) {
        return;
      }

      this.input.value = next;
      this.input.dispatchEvent(this.changeEvent);
      this.validateQtyRules();
    }
    validateQtyRules() {
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const min = parseInt(this.input.min);
        this.subtract.classList.toggle('disabled', value <= min);
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        this.add.classList.toggle('disabled', value >= max);
      }
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.additional_images = this.querySelectorAll('.product-secondary-image');
      this.additional_images_nav = this.querySelectorAll('.product-secondary-images-nav li');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
      this.size_options = this.querySelector('.product-card-sizes');
    }
    connectedCallback() {
      if (this.swatches) {
        this.enableSwatches(this.swatches, this.image);
      }
      if (this.additional_images) {
        this.enableAdditionalImages();
      }
      if (this.quick_add) {
        this.enableQuickAdd();
      }
      if (this.size_options) {
        this.enableSizeOptions();
      }
    }
    enableAdditionalImages() {
      let image_length = this.additional_images.length;
      let images = this.additional_images;
      let nav = this.additional_images_nav;
      let image_container = this.querySelector('.product-featured-image-link');
      const mousemove = function (e) {
        let l = e.offsetX;
        let w = this.getBoundingClientRect().width;
        let prc = l / w;
        let sel = Math.floor(prc * image_length);
        let selimg = images[sel];
        images.forEach((image, index) => {
          if (image.classList.contains('hover')) {
            image.classList.remove('hover');
            if (nav.length) {
              nav[index].classList.remove('active');
            }
          }
        });
        if (selimg) {
          if (!selimg.classList.contains('hover')) {
            selimg.classList.add('hover');
            if (nav.length) {
              nav[sel].classList.add('active');
            }
          }
        }

      };
      const mouseleave = function (e) {
        images.forEach((image, index) => {
          image.classList.remove('hover');
          if (nav.length) {
            nav[index].classList.remove('active');
          }
        });
      };
      if (image_container) {
        image_container.addEventListener('touchstart', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchmove', mousemove, {
          passive: true
        });
        image_container.addEventListener('touchend', mouseleave, {
          passive: true
        });
        image_container.addEventListener('mouseenter', mousemove, {
          passive: true
        });
        image_container.addEventListener('mousemove', mousemove, {
          passive: true
        });
        image_container.addEventListener('mouseleave', mouseleave, {
          passive: true
        });
      }

      images.forEach(function (image) {
        window.addEventListener('load', (event) => {
          lazySizes.loader.unveil(image);
        });
      });

    }
    enableSwatches(swatches, image) {
      let swatch_list = swatches.querySelectorAll('.product-card-swatch'),
        org_srcset = image ? image.dataset.srcset : '';
      this.color_index = this.swatches.dataset.index;

      swatch_list.forEach((swatch, index) => {
        window.addEventListener('load', (event) => {
          let image = new Image();
          image.srcset = swatch.dataset.srcset;
          lazySizes.loader.unveil(image);
        });

        swatch.addEventListener('mouseover', () => {
          [].forEach.call(swatch_list, function (el) {
            el.classList.remove('active');
          });
          if (image) {
            if (swatch.dataset.srcset) {
              image.setAttribute('srcset', swatch.dataset.srcset);
            } else {
              image.setAttribute('srcset', org_srcset);
            }
          }
          if (this.size_options) {
            this.current_options[this.color_index] = swatch.querySelector('span').innerText;
            this.updateMasterId();
          }
          swatch.classList.add('active');
        });
        swatch.addEventListener('click', function (evt) {
          window.location.href = this.dataset.href;
          evt.preventDefault();
        });
      });
    }
    enableQuickAdd() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }
    enableSizeOptions() {
      let size_list = this.size_options.querySelectorAll('.product-card-sizes--size'),
        featured_image = this.querySelector('.product-featured-image'),
        has_hover = featured_image.classList.contains('thb-hover'),
        size_parent = this.size_options.parentElement;

      this.size_index = this.size_options.dataset.index;

      this.current_options = this.size_options.dataset.options.split(',');

      this.updateMasterId();

      size_parent.addEventListener('mouseenter', () => {
        if (has_hover) {
          featured_image.classList.remove('thb-hover');
        }
      }, {
        passive: true
      });
      size_parent.addEventListener('mouseleave', () => {
        if (has_hover) {
          featured_image.classList.add('thb-hover');
        }
      }, {
        passive: true
      });
      size_list.forEach((size) => {
        size.addEventListener('click', (evt) => {
          evt.preventDefault();

          if (size.classList.contains('is-disabled')) {
            return;
          }
          this.current_options[this.size_index] = size.querySelector('span').innerText;
          this.updateMasterId();

          size.classList.add('loading');
          size.setAttribute('aria-disabled', true);
          const config = {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Accept': 'application/javascript'
            }
          };
          let formData = new FormData();

          formData.append('id', this.currentVariant.id);
          formData.append('quantity', 1);
          formData.append('sections', this.getSectionsToRender().map((section) => section.section));
          formData.append('sections_url', window.location.pathname);

          config.body = formData;

          fetch(`${theme.routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                return;
              }
              this.renderContents(response);

              dispatchCustomEvent('cart:item-added', {
                product: response.hasOwnProperty('items') ? response.items[0] : response
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              size.classList.remove('loading');
              size.removeAttribute('aria-disabled');
            });
        });
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.current_options[index] === option;
        }).includes(false);
      });
      setTimeout(() => {
        this.setDisabled();
      }, 100);
    }
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
    setDisabled() {
      const variant_data = this.getVariantData();

      if (variant_data) {

        if (this.currentVariant) {
          const selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });

          const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

          const fieldset_options = Object.values(available_options)[this.size_index];
          if (fieldset_options) {
            if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
              this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        } else {
          if (this.size_options.querySelectorAll('.product-card-sizes--size').length) {
            this.size_options.querySelectorAll('.product-card-sizes--size').forEach((input, input_i) => {
              input.classList.add('is-disabled');
            });
          }
        }

      }
      return true;
    }
    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }
    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData();

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (section.id === 'Cart-Drawer') {
          const drawer = document.getElementById('Cart-Drawer');
          drawer?.copyDrawerState(parsedState.sections[section.section]);
          drawer?.evaluateMilestones();
          drawer?.notesToggle();
          drawer?.removeProductEvent();
          drawer?.syncFreeGift();
        }

        if (section.id === 'Cart' && typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.getElementById('Cart-Drawer').classList.add('active');
        document.body.classList.add('open-cart');
        document.body.classList.add('open-cc');
        if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
          document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
        }
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}


/**
 *  @class
 *  @function PanelClose
 */
if (!customElements.get('side-panel-close')) {
  class PanelClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');

      this.onClick = (e) => {
        let panel = document.querySelectorAll('.side-panel.active');
        if (panel.length) {
          this.close_panel(e, panel[0]);
        }
      };
      // Add functionality to buttons
      this.addEventListener('click', this.onClick.bind(this));
      document.addEventListener('panel:close', this.onClick.bind(this));
      if (!this.cc.hasAttribute('initialized')) {
        this.cc.addEventListener('click', this.onClick.bind(this));
        this.cc.setAttribute('initialized', '');
      }

    }
    close_panel(e, panel) {
      if (e) {
        e.preventDefault();
      }
      if (!panel) {
        panel = e?.target.closest('.side-panel.active');

        if (!panel) {
          return;
        }
      }
      if (panel.classList.contains('product-drawer') || document.body.classList.contains('open-quick-view')) {
        this.close_quick_view();
      } else if (panel.classList.contains('cart-drawer')) {
        if (panel.querySelector('.product-recommendations--full')) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.querySelector('.product-recommendations--full').classList.remove('active');
          }
        }
        if (window.innerWidth < 1069) {
          if (!document.body.classList.contains('open-quick-view')) {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          } else {
            this.close_quick_view();
          }
        } else {
          if (panel.querySelector('.product-recommendations--full')) {
            if (!document.body.classList.contains('open-quick-view')) {
              setTimeout(() => {
                panel.classList.remove('active');
                document.body.classList.remove('open-cc');
                document.body.classList.remove('open-cart');
              }, 500);
            } else {
              this.close_quick_view();
            }
          } else {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
            document.body.classList.remove('open-cart');
          }
        }
      } else {
        panel.classList.remove('active');
        document.body.classList.remove('open-cc');
      }
    }
    close_quick_view() {
      let panel = document.getElementById('Product-Drawer');

      if (panel.querySelector('.product-quick-images--container')) {
        panel.querySelector('.product-quick-images--container').classList.remove('active');
      }
      if (window.innerWidth < 1069) {
        panel.classList.remove('active');
        if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
          document.body.classList.remove('open-cc');
        }
        document.body.classList.remove('open-quick-view');
      } else {
        if (panel.querySelector('.product-quick-images--container')) {
          setTimeout(() => {
            panel.classList.remove('active');
            if (!document.body.classList.contains('open-cart') || !document.body.classList.contains('open-quick-view')) {
              document.body.classList.remove('open-cc');
            }
            document.body.classList.remove('open-quick-view');
            panel.querySelector('#Product-Drawer-Content').innerHTML = '';
          }, 500);
        }
      }
    }
  }
  customElements.define('side-panel-close', PanelClose);

  document.addEventListener('keyup', (e) => {
    if (e.code) {
      if (e.code.toUpperCase() === 'ESCAPE') {
        dispatchCustomEvent('panel:close');
      }
    }
  });
}
/**
 *  @class
 *  @function CartDrawer
 */
if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {

    constructor() {
      super();
      this._giftBusy = false;
      this._requestQueue = Promise.resolve();
      this._milestonesReady = false;
      this._shippingWasUnlocked = false;
      this._giftWasUnlocked = false;
      this._confettiTimer = null;
      this._confettiRaf = null;
    }

    connectedCallback() {
      if (this.dataset.bound === 'true') {
        this.setupDrawerUi();
        return;
      }
      this.dataset.bound = 'true';

      const button = document.getElementById('cart-drawer-toggle');
      if (button) {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      }

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      document.addEventListener('cart:refresh', () => {
        this.refresh();
      });
      document.addEventListener('cart:item-added', () => {
        this.evaluateMilestones();
        this.syncFreeGift();
      });
      document.addEventListener('line-item:change:end', () => {
        this.evaluateMilestones();
        this.syncFreeGift();
      });

      this.addEventListener('change', this.debouncedOnChange.bind(this));
      this.addEventListener('click', this.onDelegatedClick.bind(this));
      this.addEventListener('submit', this.onDelegatedSubmit.bind(this));

      this.setupDrawerUi();
      this.initMilestones();
      this.syncFreeGift();
    }

    open() {
      document.body.classList.add('open-cc');
      document.body.classList.add('open-cart');
      this.classList.add('active');
      this.focus();
      setTimeout(() => {
        this.querySelector('.product-recommendations--full')?.classList.add('active');
      });
      dispatchCustomEvent('cart-drawer:open');
    }

    onDelegatedClick(event) {
      const remove = event.target.closest('.remove');
      if (remove && this.contains(remove)) {
        event.preventDefault();
        this.updateQuantity(remove.dataset.index, '0');
        return;
      }

      const upsellAdd = event.target.closest('[data-cart-upsell-add]');
      if (upsellAdd && this.contains(upsellAdd)) {
        event.preventDefault();
        this.addUpsell(upsellAdd);
        return;
      }

      if (event.target.closest('[data-cart-continue]')) {
        event.preventDefault();
        dispatchCustomEvent('panel:close');
        return;
      }

      if (event.target.closest('[data-cart-note-toggle]')) {
        event.preventDefault();
        this.querySelector('.cd-note-panel, .order-note-toggle__content')?.classList.add('active');
        return;
      }

      if (event.target.closest('[data-cart-note-save]')) {
        event.preventDefault();
        this.querySelector('.cd-note-panel, .order-note-toggle__content')?.classList.remove('active');
        this.saveNotes();
        return;
      }

      if (event.target.closest('[data-upsell-prev]')) {
        event.preventDefault();
        this.scrollUpsell(-1);
        return;
      }

      if (event.target.closest('[data-upsell-next]')) {
        event.preventDefault();
        this.scrollUpsell(1);
      }
    }

    onDelegatedSubmit(event) {
      const form = event.target.closest('[data-cart-discount-form]');
      if (!form || !this.contains(form)) {
        return;
      }
      event.preventDefault();
      this.applyDiscount(form);
    }

    onChange(event) {
      if (event.target.classList.contains('qty')) {
        const quantity = parseInt(event.target.value, 10);
        this.updateQuantity(event.target.dataset.index, Number.isNaN(quantity) ? 0 : quantity);
      }
    }

    removeProductEvent() {
      this.setupDrawerUi();
    }

    notesToggle() {
      this.setupDrawerUi();
    }

    setupDrawerUi() {
      this.initUpsellSlider();
    }

    isShippingUnlocked() {
      if (String(this.dataset.shippingEnabled) !== 'true') {
        return false;
      }
      const threshold = parseInt(this.dataset.shippingThreshold, 10) || 0;
      const qualifying = parseInt(this.dataset.qualifyingTotal, 10) || 0;
      return threshold > 0 && qualifying >= threshold;
    }

    isGiftUnlocked() {
      if (String(this.dataset.giftEnabled) !== 'true') {
        return false;
      }
      const threshold = parseInt(this.dataset.giftThreshold, 10) || 0;
      const qualifying = parseInt(this.dataset.qualifyingTotal, 10) || 0;
      return threshold > 0 && qualifying >= threshold;
    }

    initMilestones() {
      this._shippingWasUnlocked = this.isShippingUnlocked();
      this._giftWasUnlocked = this.isGiftUnlocked();
      this._milestonesReady = true;
    }

    evaluateMilestones() {
      if (!this._milestonesReady) {
        this.initMilestones();
        return;
      }

      const shippingNow = this.isShippingUnlocked();
      const giftNow = this.isGiftUnlocked();
      const crossedShipping = !this._shippingWasUnlocked && shippingNow;
      const crossedGift = !this._giftWasUnlocked && giftNow;

      this._shippingWasUnlocked = shippingNow;
      this._giftWasUnlocked = giftNow;

      if (crossedShipping || crossedGift) {
        this.playCelebration();
      }
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    stopCelebration() {
      if (this._confettiRaf) {
        cancelAnimationFrame(this._confettiRaf);
        this._confettiRaf = null;
      }
      window.clearTimeout(this._confettiTimer);
      this._confettiTimer = null;
      this.querySelectorAll('.cd-confetti').forEach((el) => el.remove());
    }

    playCelebration() {
      this.stopCelebration();
      if (this.prefersReducedMotion()) {
        return;
      }

      const canvas = document.createElement('canvas');
      canvas.className = 'cd-confetti';
      const host = this.querySelector('.cd-content') || this;
      canvas.setAttribute('aria-hidden', 'true');
      host.appendChild(canvas);

      const ctx = canvas.getContext('2d');
      if (!ctx) {
        canvas.remove();
        return;
      }

      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const size = () => {
        const width = Math.max(1, host.clientWidth);
        const height = Math.max(1, host.clientHeight);
        canvas.width = Math.floor(width * dpr);
        canvas.height = Math.floor(height * dpr);
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        return { width, height };
      };

      const { width, height } = size();
      const originX = width * 0.5;
      const originY = height - 12;
      const colors = [
        '#ff4fa3',
        '#ff2d6f',
        '#ff7a1a',
        '#ffd400',
        '#ffe566',
        '#3ad1ff',
        '#1ea7ff',
        '#7dff4a',
        '#b6ff3c',
        '#c44dff',
        '#ff3b3b',
        '#ff9ad5'
      ];
      const count = 280;
      const particles = [];

      for (let i = 0; i < count; i += 1) {
        const fan = (Math.random() + Math.random() + Math.random()) / 3 - 0.5;
        const angle = -Math.PI / 2 + fan * 1.7;
        const speed = 14 + Math.random() * 18;
        const shapeRoll = Math.random();
        const isDot = shapeRoll > 0.78;
        const isRibbon = !isDot && shapeRoll > 0.38;
        particles.push({
          x: originX + (Math.random() - 0.5) * 36,
          y: originY + (Math.random() - 0.5) * 10,
          vx: Math.cos(angle) * speed * (0.9 + Math.random() * 0.55),
          vy: Math.sin(angle) * speed * (0.95 + Math.random() * 0.35),
          gravity: 0.26 + Math.random() * 0.14,
          drag: 0.988 + Math.random() * 0.008,
          w: isDot ? 3.2 + Math.random() * 2.4 : isRibbon ? 2.2 + Math.random() * 2.2 : 4 + Math.random() * 4,
          h: isDot ? 3.2 + Math.random() * 2.4 : isRibbon ? 9 + Math.random() * 10 : 5 + Math.random() * 6,
          rot: Math.random() * Math.PI * 2,
          vr: (Math.random() - 0.5) * 0.5,
          color: colors[Math.floor(Math.random() * colors.length)],
          shape: isDot ? 'circle' : 'rect',
          life: 1,
          fade: 0.0024 + Math.random() * 0.0022,
          delay: Math.random() * 90
        });
      }

      const started = performance.now();
      const maxMs = 2500;
      let last = started;

      const tick = (now) => {
        const elapsed = now - started;
        const dt = Math.min(2.2, (now - last) / 16.67);
        last = now;
        ctx.clearRect(0, 0, width, height);

        let alive = 0;
        for (let i = 0; i < particles.length; i += 1) {
          const p = particles[i];
          if (elapsed < p.delay) {
            alive += 1;
            continue;
          }
          p.vx *= Math.pow(p.drag, dt);
          p.vy += p.gravity * dt;
          p.x += p.vx * dt;
          p.y += p.vy * dt;
          p.rot += p.vr * dt;
          p.life -= p.fade * dt;
          if (p.life <= 0 || p.y > height + 30) {
            continue;
          }
          alive += 1;

          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.globalAlpha = Math.max(0, Math.min(1, p.life));
          ctx.fillStyle = p.color;
          if (p.shape === 'circle') {
            ctx.beginPath();
            ctx.arc(0, 0, p.w * 0.42, 0, Math.PI * 2);
            ctx.fill();
          } else if (p.shape === 'ribbon') {
            ctx.fillRect(-p.w * 0.22, -p.h * 0.7, p.w * 0.44, p.h * 1.4);
          } else {
            ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
          }
          ctx.restore();
        }

        if (alive === 0 || elapsed > maxMs) {
          this.stopCelebration();
          return;
        }
        this._confettiRaf = requestAnimationFrame(tick);
      };

      this._confettiRaf = requestAnimationFrame(tick);
      this._confettiTimer = window.setTimeout(() => {
        this.stopCelebration();
      }, maxMs + 80);
    }

    getSectionsToRender() {
      return [{
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }

    getSectionInnerHTML(html, selector) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const el = parsed.querySelector(selector);
      return el ? el.innerHTML : '';
    }

    renderContents(parsedState, fromRefresh) {
      this.getSectionsToRender().forEach((section) => {
        const root = document.getElementById(section.id);
        if (!root) {
          return;
        }
        const elementToReplace = root.querySelector(section.selector) || root;
        const html = fromRefresh ? parsedState[section.section] : parsedState.sections?.[section.section];
        if (!html) {
          return;
        }
        if (section.id === 'Cart-Drawer') {
          this.copyDrawerState(html);
          const inner = root.querySelector('.side-panel-inner');
          const parsed = new DOMParser().parseFromString(html, 'text/html');
          const freshInner = parsed.querySelector('.side-panel-inner');
          if (inner && freshInner) {
            inner.innerHTML = freshInner.innerHTML;
            return;
          }
        }
        elementToReplace.innerHTML = this.getSectionInnerHTML(html, section.selector);
      });
      this.setupDrawerUi();
      this.evaluateMilestones();
    }

    copyDrawerState(html) {
      if (!html) {
        return;
      }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.getElementById('Cart-Drawer')
        || parsed.querySelector('cart-drawer')
        || parsed.querySelector('[data-qualifying-total]');
      if (!fresh) {
        return;
      }
      const attrs = [
        'qualifying-total',
        'shipping-threshold',
        'shipping-enabled',
        'gift-threshold',
        'gift-enabled',
        'gift-variant-id',
        'gift-product-id',
        'gift-line',
        'gift-qty',
        'gift-key',
        'gift-variant-in-cart'
      ];
      attrs.forEach((attr) => {
        const camel = attr.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
        const value = fresh.getAttribute(`data-${attr}`);
        if (value == null) {
          delete this.dataset[camel];
        } else {
          this.dataset[camel] = value;
        }
      });
    }

    saveNotes() {
      const notes = document.getElementById('mini-cart__notes');
      if (!notes) {
        return;
      }
      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          note: notes.value
        })
      });
    }

    queueRequest(task) {
      this._requestQueue = this._requestQueue.then(task).catch((error) => {
        console.error(error);
      });
      return this._requestQueue;
    }

    updateQuantity(line, quantity, options = {}) {
      const skipGift = options.skipGift === true;
      this.querySelector(`#CartDrawerItem-${line}`)?.classList.add('thb-loading');
      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });

      dispatchCustomEvent('line-item:change:start', {
        quantity: quantity
      });
      this.querySelector('.product-recommendations--full')?.classList.remove('active');

      return this.queueRequest(() => fetch(`${theme.routes.cart_change_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      })
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          if (parsedState.sections) {
            this.renderContents(parsedState);
          }
          dispatchCustomEvent('line-item:change:end', {
            quantity: quantity,
            cart: parsedState
          });
          this.querySelector(`#CartDrawerItem-${line}`)?.classList.remove('thb-loading');
          if (!skipGift) {
            this.syncFreeGift();
          }
          return parsedState;
        }));
    }

    refresh() {
      this.querySelector('.product-recommendations--full')?.classList.remove('active');
      const sections = 'cart-drawer,cart-bubble';
      return this.queueRequest(() => fetch(`${window.location.pathname}?sections=${sections}`)
        .then((response) => response.text())
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.renderContents(parsedState, true);
          this.syncFreeGift();
        }));
    }

    addItems(items, options = {}) {
      const skipGift = options.skipGift === true;
      const formData = new FormData();
      formData.append('id', items[0].id);
      formData.append('quantity', items[0].quantity || 1);
      if (items[0].properties) {
        Object.keys(items[0].properties).forEach((key) => {
          formData.append(`properties[${key}]`, items[0].properties[key]);
        });
      }
      formData.append('sections', this.getSectionsToRender().map((section) => section.section).join(','));
      formData.append('sections_url', window.location.pathname);

      return this.queueRequest(() => fetch(`${theme.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        },
        body: formData
      })
        .then((response) => response.json())
        .then((parsedState) => {
          if (parsedState.status) {
            throw parsedState;
          }
          this.renderContents(parsedState);
          this.open();
          dispatchCustomEvent('cart:item-added', {
            product: parsedState.hasOwnProperty('items') ? parsedState.items[0] : parsedState
          });
          if (!skipGift) {
            this.syncFreeGift();
          }
          return parsedState;
        }));
    }

    addUpsell(button) {
      if (button.disabled || button.classList.contains('is-loading')) {
        return;
      }
      const variantId = button.dataset.variantId;
      if (!variantId) {
        return;
      }
      button.classList.add('is-loading');
      this.addItems([{ id: variantId, quantity: 1 }])
        .catch(() => {})
        .finally(() => {
          button.classList.remove('is-loading');
        });
    }

    syncFreeGift() {
      if (this._giftBusy || this.dataset.giftEnabled !== 'true') {
        return;
      }
      const variantId = this.dataset.giftVariantId;
      const threshold = parseInt(this.dataset.giftThreshold, 10) || 0;
      const qualifying = parseInt(this.dataset.qualifyingTotal, 10) || 0;
      if (!variantId || threshold <= 0) {
        return;
      }

      const giftLine = this.querySelector('[data-free-gift-line]');
      const eligible = qualifying >= threshold;
      const giftQty = giftLine ? parseInt(giftLine.dataset.qty, 10) : 0;
      const giftIndex = giftLine ? giftLine.dataset.index : this.dataset.giftLine;

      if (eligible && !giftLine) {
        if (this.dataset.giftVariantInCart === 'true') {
          return;
        }
        this._giftBusy = true;
        this.addItems([{
          id: variantId,
          quantity: 1,
          properties: { _mame_free_gift: 'true' }
        }], { skipGift: true })
          .catch(() => {})
          .finally(() => {
            this._giftBusy = false;
          });
        return;
      }

      if (eligible && giftQty > 1 && giftIndex) {
        this._giftBusy = true;
        this.updateQuantity(giftIndex, 1, { skipGift: true })
          .finally(() => {
            this._giftBusy = false;
          });
        return;
      }

      if (!eligible && giftLine && giftIndex) {
        this._giftBusy = true;
        this.updateQuantity(giftIndex, 0, { skipGift: true })
          .finally(() => {
            this._giftBusy = false;
          });
      }
    }

    applyDiscount(form) {
      const input = form.querySelector('input[name="discount"]');
      const message = form.querySelector('[data-cart-discount-message]');
      const code = (input?.value || '').trim();
      if (!code) {
        return;
      }

      const showMessage = (text, isError) => {
        if (!message) {
          return;
        }
        message.hidden = false;
        message.textContent = text;
        message.classList.toggle('is-error', Boolean(isError));
      };

      fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ discount: code })
      })
        .then((response) => response.json())
        .then((state) => {
          if (state.status) {
            throw state;
          }
          const root = (theme.routes.root_url || '/').replace(/\/$/, '');
          return fetch(`${root}/discount/${encodeURIComponent(code)}`, {
            credentials: 'same-origin'
          }).then(() => state);
        })
        .then(() => {
          showMessage(form.dataset.success, false);
          this.refresh();
        })
        .catch(() => {
          showMessage(form.dataset.error, true);
        });
    }

    initUpsellSlider() {
      const track = this.querySelector('[data-upsell-track]');
      const slides = track ? Array.from(track.querySelectorAll('.cd-upsell__card')) : [];
      const prev = this.querySelector('[data-upsell-prev]');
      const next = this.querySelector('[data-upsell-next]');
      const dots = this.querySelector('[data-upsell-dots]');
      if (!track || !slides.length) {
        return;
      }
      const gap = 8;
      const step = Math.max(slides[0].offsetWidth + gap, 1);
      const visible = Math.max(1, Math.round((track.clientWidth + gap) / step));
      const pages = Math.max(1, slides.length - visible + 1);
      const canScroll = pages > 1;
      if (prev) prev.hidden = !canScroll;
      if (next) next.hidden = !canScroll;
      if (dots) {
        dots.hidden = !canScroll;
        dots.innerHTML = '';
        for (let index = 0; index < pages; index += 1) {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', String(index + 1));
          if (index === 0) {
            dot.classList.add('is-active');
          }
          dot.addEventListener('click', () => {
            track.scrollTo({ left: index * step, behavior: 'smooth' });
          });
          dots.appendChild(dot);
        }
        const syncDots = () => {
          const index = Math.min(pages - 1, Math.max(0, Math.round(track.scrollLeft / step)));
          dots.querySelectorAll('button').forEach((dot, i) => {
            dot.classList.toggle('is-active', i === index);
          });
        };
        if (this._onUpsellScroll) {
          track.removeEventListener('scroll', this._onUpsellScroll);
        }
        this._onUpsellScroll = syncDots;
        track.addEventListener('scroll', syncDots, { passive: true });
        syncDots();
      }
    }

    scrollUpsell(direction) {
      const track = this.querySelector('[data-upsell-track]');
      const card = track?.querySelector('.cd-upsell__card');
      if (!track || !card) {
        return;
      }
      track.scrollBy({ left: direction * (card.offsetWidth + 8), behavior: 'smooth' });
    }
  }
  customElements.define('cart-drawer', CartDrawer);
}

/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    window.addEventListener('load', () => {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });

    // delegated listener on change
    document.body.addEventListener('change', (e) => {
      if (e.target.matches('.resize-select') && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll('.resize-select').forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select'),
      offset = 13;
    tempSelect.style.visibility = 'hidden';
    tempSelect.style.position = 'fixed';
    tempSelect.appendChild(tempOption);
    if (sel.classList.contains('thb-language-code') || sel.classList.contains('thb-currency-code') || sel.classList.contains('facet-filters__sort')) {
      offset = 2;
    }
    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + offset}px`;
    }
    tempSelect.remove();
  }
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}

/**
 *  @class
 *  @function FooterMenuToggle
 */
class FooterMenuToggle {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll('.thb-widget-title.collapsible').forEach((button) => {
      button.addEventListener('click', (e) => {
        button.classList.toggle('active');
      });
    });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));

    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);

        this.body.classList.add('open-cc');
        this.body.classList.add('open-quick-view');
        this.drawer.classList.add('active');

        this.drawer.querySelector('.side-panel-close').focus();

        setTimeout(() => {
          this.drawer.querySelector('.product-quick-images--container').classList.add('active');
        });
        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
        addIdToRecentlyViewed(productHandle);
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function SidePanelContentTabs
 */
if (!customElements.get('side-panel-content-tabs')) {
  class SidePanelContentTabs extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll('button');
      this.panels = this.parentElement.querySelectorAll('.side-panel-content--tab-panel');
    }
    connectedCallback() {
      this.setupButtonObservers();
    }
    disconnectedCallback() {

    }
    setupButtonObservers() {
      this.buttons.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.toggleActiveClass(i);
        });
      });
    }
    toggleActiveClass(i) {
      this.buttons.forEach((button) => {
        button.classList.remove('tab-active');
      });
      this.buttons[i].classList.add('tab-active');

      this.panels.forEach((panel) => {
        panel.classList.remove('tab-active');
      });
      this.panels[i].classList.add('tab-active');
    }
  }

  customElements.define('side-panel-content-tabs', SidePanelContentTabs);
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

/**
 *  @function addIdToRecentlyViewed
 */
function addIdToRecentlyViewed(handle) {

  if (!handle) {
    let product = document.querySelector('.thb-product-detail');

    if (product) {
      handle = product.dataset.handle;
    }
  }
  if (!handle) {
    return;
  }
  if (window.localStorage) {
    let recentIds = window.localStorage.getItem('recently-viewed');
    if (recentIds != 'undefined' && recentIds != null) {
      window.recentlyViewedIds = JSON.parse(recentIds);
    }
  }
  // Remove current product if already in recently viewed array
  var i = window.recentlyViewedIds.indexOf(handle);

  if (i > -1) {
    window.recentlyViewedIds.splice(i, 1);
  }

  // Add id to array
  window.recentlyViewedIds.unshift(handle);

  if (window.localStorage) {
    window.localStorage.setItem('recently-viewed', JSON.stringify(window.recentlyViewedIds));
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (typeof FooterMenuToggle !== 'undefined') {
    new FooterMenuToggle();
  }
});